const formatStringToReadAbleText = (input: string): string => {
  const textWithSpaces = input.replace(/-/g, ' ');

  const textWithSeparateWords = textWithSpaces.replace(
    /([a-z])([A-Z])/g,
    '$1 $2'
  );

  const humanReadableText = textWithSeparateWords.replace(/\b\w/g, (char) =>
    char.toUpperCase()
  );

  return humanReadableText;
};

const stringUtils = { formatStringToReadAbleText };

export default stringUtils;
